<template>
  <v-container fluid class="edit-roles-page">
    <div class="pa-2 fill-height d-flex flex-column justify-start align-start">
      <v-row
        v-if="loading"
        no-gutters
        align="center"
        justify="center"
        class="fill-width"
      >
        <v-progress-circular
          :size="60"
          :width="5"
          color="primary"
          indeterminate
        />
      </v-row>
      <div
        v-else
        class="fill-width fill-height d-flex justify-space-between align-center align-content-start flex-wrap"
      >
        <div class="d-flex justify-space-between align-center fill-width">
          <v-card elevation="0" color="gray1" width="400px">
            <v-card-text class="font-semiBold-16 text-center">{{
              $t(
                "panel.adminManagement.adminsPage.editRolesPage.rolesSelection"
              )
            }}</v-card-text>
          </v-card>
          <v-btn
            color="primary"
            depressed
            :loading="loading"
            class="py-6 ms-2"
            @click="editUserRole"
            >{{
              $t("panel.adminManagement.adminsPage.editRolesPage.submit")
            }}</v-btn
          >
        </div>
        <v-row
          no-gutters
          align="center"
          justify="start"
          align-content="start"
          class="checkBoxes fill-width overflow-auto"
        >
          <v-col
            v-for="(role, index) in userRoles"
            :key="index"
            sm="6"
            md="4"
            lg="3"
            class="py-0"
          >
            <div>
              <v-checkbox
                v-model="role.selected"
                :label="role.name"
                dense
                hide-details
                class="checkbox pa-2 text-truncate mt-2"
              ></v-checkbox>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
  </v-container>
</template>

<script>
import { userInfoService } from "@/services";

export default {
  name: "edit-roles",
  props: ["userId"],
  data() {
    return {
      loading: false,
      userRoles: []
    };
  },
  mounted() {
    this.getUserRoles();
  },
  methods: {
    editUserRole() {
      this.loading = true;
      let roles = [];
      this.userRoles.map(item => {
        if (item.selected) {
          roles.push({ id: item.id, name: item.name });
        }
      });
      userInfoService
        .editUserRoles({ roles, userId: this.userId })
        .then(() => {
          this.$toast.success(
            this.$t(
              "panel.adminManagement.adminsPage.editRolesPage.successMsgToast"
            )
          );
          this.$router.replace({ name: "roles" });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getUserRoles() {
      this.loading = true;
      userInfoService
        .getUserRoles({ userId: this.userId })
        .then(response => {
          this.userRoles = response.data.data;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss">
@import "EditRoles";
</style>
